import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ApplicationContextProvider } from "./context/GlobalState";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ApplicationContextProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApplicationContextProvider>
    </HelmetProvider>
  </React.StrictMode>
);
